import { Dispatch } from 'redux';
import { typedAction } from 'store/modules/base';
import { GETValidarDiaUtil, POSTValidarDiasUteis, ConsultarDiaUtilResponse } from 'requests/feriados-nacionais';

export interface FeriadosNacionaisState {
  getValidarDiaUtil(dispatch: Dispatch, today: Date, stackRequest?: boolean): Promise<ConsultarDiaUtilResponse>;
  postValidarDiasUteis(dispatch: Dispatch, datas: Date[], stackRequest?: boolean): Promise<ConsultarDiaUtilResponse[]>;
}

const feriadosNacionaisInitialState: FeriadosNacionaisState = {
  getValidarDiaUtil: GETValidarDiaUtil,
  postValidarDiasUteis: POSTValidarDiasUteis,
};

enum FeriadosNacionaisActionType {
  Update = 'feriadosNacionais/UPDATE',
  Reset = 'feriadosNacionais/RESET',
}

export const updateFeriadosNacionais = (state: FeriadosNacionaisState) => {
  return typedAction(FeriadosNacionaisActionType.Update, state);
};

export const resetFeriadosNacionais = () => {
  return typedAction(FeriadosNacionaisActionType.Reset);
};

type FeriadosNacionaisAction = ReturnType<typeof updateFeriadosNacionais | typeof resetFeriadosNacionais>;

export function feriadosNacionaisReducer(
  state: FeriadosNacionaisState = feriadosNacionaisInitialState,
  action: FeriadosNacionaisAction
): FeriadosNacionaisState {
  switch (action.type) {
    case FeriadosNacionaisActionType.Update:
      return { ...action.payload };
    case FeriadosNacionaisActionType.Reset:
      return { ...feriadosNacionaisInitialState };
    default:
      return state;
  }
}
